export default __webpack_public_path__ + "static/benefitBgImage-1de09389f8785320cc9cc7317c1224f0.png";